// VIP 12 - Page 4: REBOA
// 4-1. CPR Monitoring Data
// 4-2. REBOA Data
// 4-3. Device Related Complications
// 4-4. Vascular access-related complications
// 4-5. Other Adverse Events

import React, { useEffect } from "react";

const Page4 = ({ formData, handleChange, handleCheckboxChange, dtDisplay }) => {
  // 디버깅: Page4 로드 시 formData 구조 출력
  useEffect(() => {
    console.log("=== [DEBUG] Page4 formData 구조 ===");
    console.log("전체 formData:", formData);
    console.log("Page4 관련 필드들:", {
      // REBOA Procedure
      art_sheath_ins: formData.art_sheath_ins,
      art_sheath_ins_site: formData.art_sheath_ins_site,
      art_sheath_ins_attempts: formData.art_sheath_ins_attempts,
      cline_ins: formData.cline_ins,
      cline_ins_site: formData.cline_ins_site,
      cline_ins_attempts: formData.cline_ins_attempts,
      abp_start_datetime: formData.abp_start_datetime,
      cvp_start_datetime: formData.cvp_start_datetime,
      reboa_ins: formData.reboa_ins,
      reboa_ins_datetime: formData.reboa_ins_datetime,
      reboa_ins_depth: formData.reboa_ins_depth,
      reboa_ins_attempts: formData.reboa_ins_attempts,
      reboa_confirm: formData.reboa_confirm,
      reboa_inflation_datetime: formData.reboa_inflation_datetime,
      reboa_inflation_vol: formData.reboa_inflation_vol,
      reboa_deflation_datetime: formData.reboa_deflation_datetime,
      // Device Related Complications
      ae_malposition: formData.ae_malposition,
      ae_ins_fail: formData.ae_ins_fail,
      ae_ins_hematoma: formData.ae_ins_hematoma,
      ae_ins_infection: formData.ae_ins_infection,
      ae_balloon_rupture: formData.ae_balloon_rupture,
      ae_removal_failure: formData.ae_removal_failure,
      // Vascular Complications
      ae_fem_art_inj: formData.ae_fem_art_inj,
      ae_limb_isch: formData.ae_limb_isch,
      ae_amputation: formData.ae_amputation,
      ae_aorta_inj: formData.ae_aorta_inj,
      // Other Adverse Events
      ae_aki_dialysis: formData.ae_aki_dialysis,
      ae_ards: formData.ae_ards,
      ae_bacteremia: formData.ae_bacteremia,
      ae_pneumonia: formData.ae_pneumonia,
      ae_sepsis: formData.ae_sepsis,
      ae_stroke: formData.ae_stroke,
      ae_paraplegia: formData.ae_paraplegia,
      ae_mi: formData.ae_mi,
      ae_mof: formData.ae_mof,
      ae_spinal_ische: formData.ae_spinal_ische,
      ae_vent_days: formData.ae_vent_days,
      ae_icu_stay: formData.ae_icu_stay,
      ae_hospital_stay: formData.ae_hospital_stay,
      ae_hospital_mortality: formData.ae_hospital_mortality,
      ae_mortality_hours: formData.ae_mortality_hours,
      ae_mortality_days: formData.ae_mortality_days,
    });

    // 현재 전송 버튼을 누르면 어떻게 전송될지 시뮬레이션
    const filteredFormData = Object.entries(formData).reduce(
      (acc, [key, value]) => {
        if (Array.isArray(value) && value.length === 0) return acc;
        if (typeof value === "string" && value.trim() === "") return acc;
        if (value === null || value === undefined) return acc;
        return { ...acc, [key]: value };
      },
      {}
    );

    console.log("Page4에서 전송될 데이터 (빈 값 제외):", filteredFormData);
    console.log("전송 API 정보:", {
      endpoint: "https://product.idea2m.com/api/vip12/save",
      method: "POST",
      payload: {
        formData: filteredFormData,
        projectId: "12",
        caseId: formData.case_id || formData.data_id,
      },
    });
    console.log("=== [DEBUG] Page4 끝 ===");
  }, [formData]);
  // 라디오 버튼 전용 핸들러
  const handleRadioClick = (e) => {
    const { name, value } = e.target;

    // 현재 선택된 값과 클릭된 값이 같으면 해제, 다르면 선택
    if (formData[name] === value) {
      handleChange({ target: { name, value: "" } });
    } else {
      handleChange({ target: { name, value } });
    }
  };

  // 재사용 가능한 라디오 필드 렌더링 함수
  const renderRadioField = (
    fieldName,
    label,
    options,
    isRequired = false,
    columnType = "2col"
  ) => {
    const wrapperClass =
      columnType === "1col" ? "input-wrapper-1column" : "input-wrapper-2column";
    const blockClass =
      columnType === "1col" ? "block-1column" : "block-2column";
    const titleClass =
      columnType === "1col" ? "item_title_1col" : "item_title_2col";
    const inputClass = columnType === "1col" ? "input_1col" : "input_2col";

    return (
      <div className={wrapperClass}>
        <div className={blockClass}>
          <label className={titleClass}>
            {label}
            {isRequired && <span className="required-mark"> *</span>}
          </label>
          <div className={inputClass}>
            <div className="rad-group">
              {options.map((option) => (
                <label key={option.value} className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name={fieldName}
                    value={option.value}
                    checked={formData[fieldName] === option.value}
                    onClick={handleRadioClick}
                    onChange={() => {}}
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">{option.label}</div>
                </label>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // 텍스트 입력 필드 렌더링 함수
  const renderTextField = (
    fieldName,
    label,
    placeholder = "",
    unit = "",
    isRequired = false,
    type = "text"
  ) => {
    return (
      <div className="block-2column">
        <label className="item_title_2col">
          {label}
          {isRequired && <span className="required-mark"> *</span>}
        </label>
        <div className="input_2col">
          <input
            type={type}
            name={fieldName}
            placeholder={placeholder}
            value={formData[fieldName] || ""}
            onChange={handleChange}
          />
          {unit && <span className="unit-text">{unit}</span>}
        </div>
      </div>
    );
  };

  return (
    <section className="vip-form-section">
      <h2 className="section-subtitle">REBOA</h2>

      {/* 4-1. CPR Monitoring Data */}
      <fieldset className="basic-info-fieldset">
        <legend>4-1. CPR Monitoring Data</legend>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">Arterial sheath insertion</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="art_sheath_ins"
                      value={option.value}
                      checked={formData.art_sheath_ins === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">
              Arterial sheath insertion site
            </label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "right femoral", value: "right femoral" },
                  { label: "left femoral", value: "left femoral" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="art_sheath_ins_site"
                      value={option.value}
                      checked={formData.art_sheath_ins_site === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          {renderTextField(
            "art_sheath_ins_attempts",
            "Arterial sheath insertion number of attempts",
            "",
            "times"
          )}
          <div className="block-2column">
            <label className="item_title_2col">Central line insertion</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="cline_ins"
                      value={option.value}
                      checked={formData.cline_ins === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Central line insertion site
            </label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "right IJV", value: "right IJV" },
                  { label: "left IJV", value: "left IJV" },
                  { label: "right SC", value: "right SC" },
                  { label: "left SC", value: "left SC" },
                  { label: "right femoral", value: "right femoral" },
                  { label: "left femoral", value: "left femoral" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="cline_ins_site"
                      value={option.value}
                      checked={formData.cline_ins_site === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          {renderTextField(
            "cline_ins_attempts",
            "Central line insertion number of attempts",
            "",
            "times"
          )}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField(
            "abp_start_datetime",
            "ABP monitoring start time",
            "",
            "",
            false,
            "datetime-local"
          )}
          {renderTextField(
            "cvp_start_datetime",
            "CVP monitoring start time",
            "",
            "",
            false,
            "datetime-local"
          )}
        </div>
      </fieldset>

      {/* 4-2. REBOA Data */}
      <fieldset className="basic-info-fieldset">
        <legend>4-2. REBOA Data</legend>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">REBOA inserted</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="reboa_ins"
                      value={option.value}
                      checked={formData.reboa_ins === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          {renderTextField(
            "reboa_ins_datetime",
            "REBOA catheter insertion time",
            "",
            "",
            false,
            "datetime-local"
          )}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField(
            "reboa_ins_depth",
            "REBOA catheter insertion depth",
            "",
            "cm"
          )}
          {renderTextField(
            "reboa_ins_attempts",
            "REBOA catheter insertion number of attempts",
            "",
            "times"
          )}
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">
              Method of REBOA placement confirmation
            </label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "ultrasound", value: "ultrasound" },
                  { label: "TEE", value: "TEE" },
                  { label: "X-ray", value: "X-ray" },
                  { label: "none", value: "none" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="reboa_confirm"
                      value={option.value}
                      checked={formData.reboa_confirm === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          {renderTextField(
            "reboa_inflation_datetime",
            "REBOA inflation time",
            "",
            "",
            false,
            "datetime-local"
          )}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField(
            "reboa_inflation_vol",
            "REBOA inflation volume",
            "",
            "cc"
          )}
          {renderTextField(
            "reboa_deflation_datetime",
            "REBOA deflation time",
            "",
            "",
            false,
            "datetime-local"
          )}
        </div>
      </fieldset>

      {/* 4-3. Device Related Complications */}
      <fieldset className="basic-info-fieldset">
        <legend>4-3. Device Related Complications</legend>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">Malposition</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_malposition"
                      value={option.value}
                      checked={formData.ae_malposition === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">Insertion failure</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_ins_fail"
                      value={option.value}
                      checked={formData.ae_ins_fail === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">Insertion site hematoma</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_ins_hematoma"
                      value={option.value}
                      checked={formData.ae_ins_hematoma === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">Insertion site infection</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_ins_infection"
                      value={option.value}
                      checked={formData.ae_ins_infection === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">Balloon rupture</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_balloon_rupture"
                      value={option.value}
                      checked={formData.ae_balloon_rupture === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">Catheter removal failure</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_removal_failure"
                      value={option.value}
                      checked={formData.ae_removal_failure === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      {/* 4-4. Vascular access-related complications */}
      <fieldset className="basic-info-fieldset">
        <legend>4-4. Vascular access-related complications</legend>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">Femoral artery injury</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_fem_art_inj"
                      value={option.value}
                      checked={formData.ae_fem_art_inj === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">Lower limb ischemia</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_limb_isch"
                      value={option.value}
                      checked={formData.ae_limb_isch === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">Amputation</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_amputation"
                      value={option.value}
                      checked={formData.ae_amputation === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">Aorta injury</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_aorta_inj"
                      value={option.value}
                      checked={formData.ae_aorta_inj === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      {/* 4-5. Other Adverse Events */}
      <fieldset className="basic-info-fieldset">
        <legend>4-5. Other Adverse Events</legend>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">AKI with dialysis</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_aki_dialysis"
                      value={option.value}
                      checked={formData.ae_aki_dialysis === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">ARDS</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_ards"
                      value={option.value}
                      checked={formData.ae_ards === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">Bacteremia</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_bacteremia"
                      value={option.value}
                      checked={formData.ae_bacteremia === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">Pneumonia</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_pneumonia"
                      value={option.value}
                      checked={formData.ae_pneumonia === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">Sepsis/Septic shock</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_sepsis"
                      value={option.value}
                      checked={formData.ae_sepsis === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">Stroke/CVA</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_stroke"
                      value={option.value}
                      checked={formData.ae_stroke === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">Paraplegia</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_paraplegia"
                      value={option.value}
                      checked={formData.ae_paraplegia === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">Myocardial infarction</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_mi"
                      value={option.value}
                      checked={formData.ae_mi === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          <div className="block-2column">
            <label className="item_title_2col">Multiorgan failure</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_mof"
                      value={option.value}
                      checked={formData.ae_mof === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="block-2column">
            <label className="item_title_2col">
              Neurologic deficit secondary to spinal cord ischemia
            </label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  { label: "yes", value: "yes" },
                  { label: "no", value: "no" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_spinal_ische"
                      value={option.value}
                      checked={formData.ae_spinal_ische === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          {renderTextField("ae_vent_days", "Ventilator days", "", "days")}
          {renderTextField("ae_icu_stay", "Length of ICU stay", "", "days")}
        </div>

        <div className="input-wrapper-2column">
          {renderTextField(
            "ae_hospital_stay",
            "Length of hospital stay",
            "",
            "days"
          )}
          <div className="block-2column">
            <label className="item_title_2col">In hospital mortality</label>
            <div className="input_2col">
              <div className="rad-group">
                {[
                  {
                    label: "survived to discharge",
                    value: "survived to discharge",
                  },
                  { label: "deceased", value: "deceased" },
                ].map((option) => (
                  <label key={option.value} className="rad-label">
                    <input
                      type="radio"
                      className="rad-input"
                      name="ae_hospital_mortality"
                      value={option.value}
                      checked={formData.ae_hospital_mortality === option.value}
                      onClick={handleRadioClick}
                      onChange={() => {}}
                    />
                    <div className="rad-design"></div>
                    <div className="rad-text">{option.label}</div>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="input-wrapper-2column">
          {renderTextField(
            "ae_mortality_hours",
            "Mortality@ hours after admission",
            "",
            "hours"
          )}
          {renderTextField(
            "ae_mortality_days",
            "Mortality@ hospital days",
            "",
            "days"
          )}
        </div>
      </fieldset>
    </section>
  );
};

export default Page4;
